var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"at-chat at-user-chat",class:{'wpguppy-rtl' : _vm.isRtl}},[_c('guppy-chat-sidebar'),_c('guppy-chat-messages'),_c('sidebar-popup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }